import styled from 'styled-components'
import { Text, TDS_DEFAULT_COLORS } from '@retailer-platform/shared-components/src/tds'

export interface PartnerNamesTextAreaProps {
  partnerNames?: string[]
  isConfirmationPage?: boolean
}

export const PartnerNamesListArea = styled.div<{ isConfirmationPage?: boolean }>(
  ({ isConfirmationPage }) => ({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '580px',
    maxHeight: isConfirmationPage ? '240px' : '140px',
    overflowY: 'auto',
    borderRadius: '8px',
    border: `1px solid ${TDS_DEFAULT_COLORS.colors.systemGrayscale30}`,
    padding: '12px',
    width: '100%',
  })
)

export const PartnerNamesTextArea = ({
  partnerNames,
  isConfirmationPage,
}: PartnerNamesTextAreaProps) => {
  if (!partnerNames || partnerNames.length === 0) {
    return null
  }

  if (partnerNames.length < 5) {
    return (
      <Text as="span" typography="bodyRegular">
        {partnerNames.join(', ')}
      </Text>
    )
  }

  return (
    <PartnerNamesListArea isConfirmationPage={isConfirmationPage}>
      {partnerNames.map(partnerName => (
        <Text key={partnerName} as="span" typography="bodyRegular">
          {`• ${partnerName}`}
        </Text>
      ))}
    </PartnerNamesListArea>
  )
}
